import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const solutions = [
  "Structured profiles with clear founder and investor data.",
  "Intelligent discovery based on thesis, stage, and sector.",
  "Quickly review founders and investors through intuitive swipe cards.",
  "Secure conversations between founders and investors.",
];

const SolutionSection = () => {
  return (
    <section className="py-24 md:py-32 bg-muted/20" aria-label="How AdV3nture solves fundraising">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl sm:text-4xl font-display font-bold mb-4 text-foreground">
              A Modern Way to Discover Early-Stage Opportunities
            </h2>
            <p className="text-muted-foreground max-w-xl mx-auto">
              AdV3nture replaces fragmented outreach with structured infrastructure designed for early-stage investing.
            </p>
          </motion.div>

          <div className="grid sm:grid-cols-2 gap-4">
            {solutions.map((solution, i) => (
              <motion.div
                key={solution}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="flex items-center gap-3 glass rounded-xl p-5 border-primary/10"
              >
                <CheckCircle2 className="w-5 h-5 text-primary shrink-0" aria-hidden="true" />
                <span className="text-sm text-foreground">{solution}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
